import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import { Code2, MapPin, Briefcase, Scroll, Book, Icon, Trophy } from 'lucide-react';
import { soccerBall } from "@lucide/lab";
import Navbar from './components/Navbar';
import Info from './components/Info';
import Footer from './components/Footer';
import Blog from './blog/Blog';
import Do from './components/Do';
import Faq from './components/Faq';
import BlogPost from './blog/BlogPost';
import Stuff from './components/Stuff';
import ImageRotator from './components/ImageRotator';
import TextRotator from './components/TextRotator';

const App = () => {
    return (
        <Router>
            <div className="main">
                <Navbar />
                <div className="container">
                    <Routes>
                        {/* Main Home Page */}
                        <Route
                            path="/"
                            element={
                                <>
                                    <div className="intro">
                                        <div className="intro-content">
                                            <div className="intro-header">
                                                <TextRotator
                                                    texts={[
                                                        { kanji: '精進', romaji: 'Shōjin', meaning: 'Diligence' },
                                                        { kanji: '武士道', romaji: 'Bushidō', meaning: 'Way of the Warrior' },
                                                        { kanji: '侘寂', romaji: 'Wabi-Sabi', meaning: 'Beauty in Imperfection' },
                                                        { kanji: '不撓不屈', romaji: 'Futō-Fukutsu', meaning: 'Indomitable Spirit' },
                                                        { kanji: '一期一会', romaji: 'Ichi-go Ichi-e', meaning: 'Once in a Lifetime' },
                                                        { kanji: '禅', romaji: 'Zen', meaning: 'Meditation' },
                                                        { kanji: '克己', romaji: 'Kokki', meaning: 'Self-Discipline' },
                                                        { kanji: '無心', romaji: 'Mushin', meaning: 'No-Mind' },
                                                        { kanji: '残心', romaji: 'Zanshin', meaning: 'Lingering Mind' },
                                                        { kanji: '守破離', romaji: 'Shu-Ha-Ri', meaning: 'Learn-Break-Transcend' },
                                                        { kanji: '不動心', romaji: 'Fudōshin', meaning: 'Immovable Mind' },
                                                        { kanji: '生き甲斐', romaji: 'Ikigai', meaning: 'Reason for Being' },
                                                        { kanji: '改善', romaji: 'Kaizen', meaning: 'Continuous Improvement' },
                                                    ]}
                                                    interval={5000}
                                                />
                                            </div>

                                            <div className="intro-details">
                                                <div className="detail-item">
                                                    <Code2 className="icon" />
                                                    <p>Fullstack Developer & PLT Enthusiast ☯️</p>
                                                </div>

                                                <div className="detail-item">
                                                    <Icon iconNode={soccerBall} className="icon" />
                                                    <p><b>SRN</b> 🔴⚫😤🚩</p>
                                                </div>

                                                <div className="detail-item">
                                                    <Scroll className="icon" />
                                                    <p>The Elder Scrolls Lore Keeper 🗿</p>
                                                </div>

                                                <div className="detail-item">
                                                    <MapPin className="icon" />
                                                    <p>Rio de Janeiro 🇧🇷</p>
                                                </div>

                                                {/*<div className="detail-item">
                                                    <Briefcase className="icon" />
                                                    <p>Currently @ <i>[redacted]</i> as Full Stack Developer</p>
                                                </div>*/}
                                            </div>
                                        </div>

                                        <div className="intro-image">
                                            <ImageRotator
                                                images={[
                                                    '/rdw2.jpg',
                                                    '/rdw3.jpg',
                                                    '/rdw.jpg',
                                                    '/rdw1.jpg',
                                                    '/rdw5.jpg',
                                                    '/rdw6.jpg',
                                                    '/rdw7.jpg',
                                                    '/rdw8.jpg',
                                                    '/rdw9.jpg',
                                                    '/rdw10.jpg',
                                                    '/rdw11.jpg',
                                                    '/rdw12.jpg',
                                                    '/rdw13.jpg',
                                                ]}
                                                interval={5000}
                                            />
                                        </div>

                                        {/*
                                        <div className="intro-visual">
                                            <div className="abstract-pattern">
                                                <div className="pattern-element"></div>
                                                <div className="pattern-element"></div>
                                                <div className="pattern-element"></div>
                                            </div>
                                        </div>
                                        */}
                                    </div>
                                    <div className="divider"></div>
                                    <div className="info">
                                        <Info />
                                    </div>
                                </>
                            }
                        />

                        <Route path="/blog" element={<Blog />} />

                        {/* Blog Post Detail Page */}
                        <Route path="/blog/:slug" element={<BlogPost />} />

                        <Route path="/do" element={<Do />} />

                        <Route path="/faq" element={<Faq />} />

                        <Route path="/stuff" element={<Stuff />} />
                    </Routes>
                </div>
                <div className="footer">
                    <Footer />
                </div>
            </div>
        </Router>
    );
};

export default App;
